
import { useState, useEffect } from 'react';

export default function TestimonialsSection() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      name: "Sarah Mitchell",
      role: "Small Business Owner",
      image: "https://public.readdy.ai/ai/img_res/a4feaf8ddf171496ced1466ee1292ef0.jpg",
      quote: "Brite Solutions saved my restaurant from bankruptcy. They negotiated my merchant cash advance debt from $180,000 down to $65,000. I can finally focus on growing my business instead of drowning in debt payments.",
      debt: "Merchant Cash Advance"
    },
    {
      name: "Michael Rodriguez",
      role: "Construction Contractor",
      image: "https://readdy.ai/api/search-image?query=Professional%20Hispanic%20man%20in%20his%2040s%20wearing%20business%20casual%20attire%2C%20confident%20smile%20in%20modern%20office%20setting%20with%20clean%20background%20and%20professional%20lighting&width=400&height=400&seq=testimonial-002&orientation=squarish",
      quote: "The team at Brite Solutions was incredible. They settled my $95,000 in business loans for just $32,000. Their expertise in business debt settlement is unmatched. Highly recommended!",
      debt: "Business Loan Settlement"
    },
    {
      name: "Jennifer Adams",
      role: "Marketing Professional",
      image: "https://readdy.ai/api/search-image?query=Professional%20woman%20in%20her%2030s%20with%20warm%20smile%20wearing%20business%20attire%20in%20bright%20modern%20office%20environment%20with%20clean%20background%20and%20natural%20lighting&width=400&height=400&seq=testimonial-003&orientation=squarish",
      quote: "I was drowning in $45,000 of credit card debt after a medical emergency. Brite Solutions helped me settle for $18,000. The stress relief is immeasurable. Thank you for giving me my life back!",
      debt: "Credit Card Debt Relief"
    },
    {
      name: "David Thompson",
      role: "Retail Store Owner",
      image: "https://readdy.ai/api/search-image?query=Professional%20African%20American%20man%20in%20his%2050s%20wearing%20business%20suit%20with%20confident%20expression%20in%20modern%20office%20setting%20with%20warm%20lighting%20and%20clean%20background&width=400&height=400&seq=testimonial-004&orientation=squarish",
      quote: "After 16 months of harassment from collection agencies, Brite Solutions negotiated a settlement that saved me over $70,000. Their professionalism and results speak for themselves.",
      debt: "Multiple Business Debts"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 8000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-20 bg-gradient-to-br from-slate-100 to-teal-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Real Results for <span className="text-orange-500">Real People</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what our clients say about their debt settlement experience with Brite Solutions.
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            {/* Client Photo */}
            <div className="flex-shrink-0">
              <div className="w-80 h-80 rounded-2xl overflow-hidden shadow-2xl border-4 border-orange-400">
                <img 
                  src={testimonials[currentTestimonial].image}
                  alt={testimonials[currentTestimonial].name}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Testimonial Content */}
            <div className="flex-1 text-center lg:text-left">
              <div className="mb-4">
                <span className="text-sm text-gray-500 uppercase tracking-wide">(Client Success Story)</span>
              </div>
              
              <div className="mb-8">
                <div className="text-6xl text-orange-400 mb-4">"</div>
                <p className="text-xl md:text-2xl text-gray-700 leading-relaxed mb-6">
                  {testimonials[currentTestimonial].quote}
                </p>
                <div className="border-l-4 border-orange-400 pl-4">
                  <div className="font-bold text-xl text-gray-900">
                    — {testimonials[currentTestimonial].name}
                  </div>
                  <div className="text-gray-600 text-lg">
                    {testimonials[currentTestimonial].role} • {testimonials[currentTestimonial].debt}
                  </div>
                </div>
              </div>

              {/* Navigation */}
              <div className="flex items-center gap-4">
                <button
                  onClick={prevTestimonial}
                  className="w-12 h-12 border-2 border-gray-300 rounded-full flex items-center justify-center hover:border-orange-500 hover:text-orange-500 transition-colors duration-300"
                >
                  <i className="fas fa-arrow-left"></i>
                </button>
                <button
                  onClick={nextTestimonial}
                  className="w-12 h-12 bg-orange-500 text-white rounded-full flex items-center justify-center hover:bg-orange-600 transition-colors duration-300"
                >
                  <i className="fas fa-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>

          {/* Dots Indicator */}
          <div className="flex justify-center mt-12 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentTestimonial(index)}
                className={`w-3 h-3 rounded-full transition-colors duration-300 ${
                  index === currentTestimonial ? 'bg-orange-500' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
